import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { CONTENT_STATUSES } from '../../../../utils/constants';
import UserContentCard from './UserContentCard/UserContentCard';
import BadgeStatus from './BadgeStatus';


export const STATUS_OPTIONS = [
  CONTENT_STATUSES.REJECTED,
  CONTENT_STATUSES.ACCEPTED,
  CONTENT_STATUSES.ACCEPTED_BUT,
  CONTENT_STATUSES.NEEDS_REVIEW,
  CONTENT_STATUSES.NEEDS_SUBMISSION
];

/**
 * @typedef {Object} UserContentCardsParams
 * @prop {import('../../../../utils/types/types').UserPostDraft[]} userContent
 * @prop {(draft, status: string)=>void)} onEdit
 *
 * @param {UserContentCardsParams} params
 * @returns
 */
export const UserContentCards = ({
  userContent,
  onEdit,
  userContentType = 'userPostDraft'
}) => (
  <React.Fragment>
    <Row>
      {userContent.map((draft, idx) => (
        <Col key={idx} sm={6} md={4} className="mb-4">
          <UserContentCard
            userContent={draft}
            userContentType={userContentType}
            onToggle={(status = null) => onEdit && onEdit(draft, status)}
          />
        </Col>
      ))}
    </Row>
  </React.Fragment>
);

export const ContentApprovalBadges = React.memo(({ statusDrafts }) =>
  <Col xs={12} lg={8}>
    <div className="d-flex mb-2 mb-sm-0 flex-wrap flex-wrap">
      {
        STATUS_OPTIONS.filter(status =>
          statusDrafts[status] > 0)
          .map(status => (
            <div key={status} className="mb-1">
              <BadgeStatus className="m-0 mr-2" status={status} />
              <div>
                {statusDrafts[status]}
              </div>
            </div>
          ))
      }
    </div>
  </Col>
);
